import type { Dict } from '../index.js';

/** Arabic: payroll and reports. Keys are the exact English text. */
export const payroll: Dict = {
  // ---- Payroll page ----
  '{n} h': '{n} س',
  '{n} h required': '{n} س مطلوبة',
  'Monthly salaries from the hours worked in each reporting period: full salary for the required hours, overtime above them.':
    'الرواتب الشهرية حسب ساعات العمل في كل فترة: الراتب كاملًا عند إتمام الساعات المطلوبة، والعمل الإضافي لما يزيد عنها.',
  'Payslips (PDF, one page each)': 'قسائم الرواتب (PDF، صفحة لكل موظف)',
  'Month (reporting period)': 'الشهر (الفترة)',
  'paid (final)': 'مدفوعة (نهائية)',
  'to prepare': 'بانتظار الإعداد',
  running: 'جارية',
  Final: 'نهائي',
  Draft: 'مسودة',
  'Hours frozen': 'الساعات مجمَّدة',
  'Hours still open': 'الساعات ما زالت مفتوحة',
  'Finalised by {name} on {date}': 'اعتمده نهائيًا {name} في {date}',
  'version {n}': 'الإصدار {n}',
  'Finalise payroll': 'اعتماد الرواتب نهائيًا',
  Reopen: 'إعادة فتح',
  'Before finalising': 'قبل الاعتماد النهائي',
  'Open Reports →': 'فتح التقارير ←',
  'Total to pay ({currency})': 'إجمالي المستحق ({currency})',
  '{n} employee': '{n} موظف',
  '{n} employees': '{n} موظفين',
  Rules: 'القواعد',
  'Overtime × {n}': 'العمل الإضافي × {n}',
  'Hourly rate = salary ÷ {hours}': 'أجر الساعة = الراتب ÷ {hours}',
  "the month's required hours": 'الساعات المطلوبة في الشهر',
  'missing hours deducted': 'الساعات الناقصة تُخصم',
  'paid by percentage of hours completed': 'الدفع بنسبة الساعات المستكملة',
  'missing hours not deducted': 'الساعات الناقصة لا تُخصم',
  change: 'تغيير',
  'Payslips (final)': 'قسائم الرواتب (نهائية)',
  'Payslips (draft — recalculated live)': 'قسائم الرواتب (مسودة — يُعاد حسابها مباشرة)',
  Base: 'الأساسي',
  Required: 'المطلوب',
  'Paid hours': 'الساعات المدفوعة',
  Overtime: 'العمل الإضافي',
  Short: 'النقص',
  'Adjust.': 'التعديلات',
  'Net pay': 'صافي الراتب',
  fixed: 'ثابت',
  'rate?': 'السعر؟',
  'No salaries yet': 'لا توجد رواتب بعد',
  "Set each engineer's salary on their employee page (Salary tab).": 'حدِّد راتب كل مهندس من صفحة الموظف (تبويب الراتب).',
  'Without a salary': 'بدون راتب',
  'These people worked in this period but have no salary set, so they are not in the payroll.':
    'عمل هؤلاء في هذه الفترة لكن لم يُحدَّد لهم راتب، لذلك لم يُدرجوا في الرواتب.',
  '→': '←',
  'Finalise payroll for {period}?': 'اعتماد رواتب {period} نهائيًا؟',
  'The payslips are frozen as shown. The rate, adjustments and the hours of this period can no longer change unless an administrator reopens the payroll with a reason.':
    'تُجمَّد قسائم الرواتب كما هي معروضة. لا يمكن بعدها تغيير سعر الصرف أو التعديلات أو ساعات هذه الفترة إلا إذا أعاد مسؤول النظام فتح الرواتب مع ذكر السبب.',
  Finalise: 'اعتماد نهائي',
  'Reopen payroll?': 'إعادة فتح الرواتب؟',
  'The final payslips are kept as an earlier version. You can then change the rate or adjustments and finalise again.':
    'تُحفظ القسائم النهائية كإصدار سابق. يمكنك بعدها تغيير سعر الصرف أو التعديلات ثم الاعتماد النهائي مجددًا.',
  'Exchange rate for this month': 'سعر الصرف لهذا الشهر',
  'Used for salaries without a fixed rate. Set it at the end of the month; engineers with a fixed rate are not affected.':
    'يُستخدم للرواتب التي ليس لها سعر صرف ثابت. حدِّده في نهاية الشهر؛ ولا يتأثر به المهندسون ذوو السعر الثابت.',
  '{from} to {to} rate': 'سعر الصرف من {from} إلى {to}',
  'Save rate': 'حفظ السعر',
  "Get today's rate online": 'جلب سعر اليوم من الإنترنت',
  'From {source}': 'من {source}',
  'online source': 'مصدر على الإنترنت',
  'Entered manually': 'أُدخل يدويًا',
  'Not set for this month yet · last month: {rate}': 'لم يُحدَّد لهذا الشهر بعد · الشهر الماضي: {rate}',
  'Not set for this month yet.': 'لم يُحدَّد لهذا الشهر بعد.',
  'Salary:': 'الراتب:',
  '× fixed rate {rate} = {amount}': '× سعر ثابت {rate} = {amount}',
  '× month rate {rate} = {amount}': '× سعر الشهر {rate} = {amount}',
  '(prorated {pct}%)': '(بالتناسب {pct}%)',
  'Hours:': 'الساعات:',
  'required {required} · worked {worked}': 'المطلوب {required} · ساعات العمل {worked}',
  '+ paid leave {hours}': '+ إجازة مدفوعة {hours}',
  'Hourly rate:': 'أجر الساعة:',
  'Overtime:': 'العمل الإضافي:',
  'Missing hours:': 'الساعات الناقصة:',
  '(not deducted)': '(لا تُخصم)',
  'No overtime on this salary.': 'لا يُحتسب عمل إضافي على هذا الراتب.',
  'Does not clock in — fixed monthly salary.': 'لا يسجِّل الحضور — راتب شهري ثابت.',
  'Net pay: {amount}': 'صافي الراتب: {amount}',
  'Day-by-day hours →': 'الساعات يومًا بيوم ←',
  'Payslip (PDF)': 'قسيمة الراتب (PDF)',
  Adjustments: 'التعديلات',
  'Remove adjustment': 'إزالة التعديل',
  'None — e.g. a bonus, allowance or advance to deduct.': 'لا يوجد — مثل مكافأة أو بدل أو سلفة تُخصم.',
  'Adjustment — {name}': 'تعديل — {name}',
  'Add (bonus, allowance…)': 'إضافة (مكافأة، بدل…)',
  'Deduct (advance, penalty…)': 'خصم (سلفة، جزاء…)',
  'Amount ({currency})': 'المبلغ ({currency})',
  'Shown on the payslip and recorded in the audit log.': 'يظهر في قسيمة الراتب ويُسجَّل في سجل التدقيق.',
  'e.g. Transport allowance': 'مثال: بدل مواصلات',

  // ---- Salary tab ----
  '{salary} at a fixed rate = {paid}': '{salary} بسعر ثابت = {paid}',
  "{salary}, paid in {currency} at each month's rate": '{salary}، يُدفع بعملة {currency} بسعر صرف كل شهر',
  'Change salary': 'تغيير الراتب',
  'Set salary': 'تحديد الراتب',
  'Monthly · since {date}': 'شهري · منذ {date}',
  'overtime paid': 'العمل الإضافي مدفوع',
  'no overtime': 'بدون عمل إضافي',
  'fixed rate {rate}': 'سعر ثابت {rate}',
  'No salary set': 'لم يُحدَّد راتب',
  "Set {name}'s monthly salary to include them in payroll.": 'حدِّد الراتب الشهري لـ {name} لإدراجه في الرواتب.',
  By: 'بواسطة',
  Upcoming: 'قادم',
  'Remove upcoming salary change': 'إزالة تغيير الراتب القادم',
  'Salary records are never edited: a change is a new line with the date it applies from. Only upcoming changes can be removed.':
    'لا تُعدَّل سجلات الرواتب أبدًا: كل تغيير سطر جديد بتاريخ سريانه. ولا يمكن إزالة إلا التغييرات القادمة.',
  'Remove upcoming salary change?': 'إزالة تغيير الراتب القادم؟',
  '{salary} from {date}.': '{salary} اعتبارًا من {date}.',
  'Monthly salary': 'الراتب الشهري',
  'e.g. {code}': 'مثال: {code}',
  'Paid in': 'عملة الدفع',
  'Applies from': 'يسري من',
  'Fixed exchange rate': 'سعر صرف ثابت',
  'The same amount every month.': 'المبلغ نفسه كل شهر.',
  "Converted at each month's {from} → {to} rate set on the Payroll page.":
    'يُحوَّل بسعر صرف {from} إلى {to} لكل شهر، المحدد في صفحة الرواتب.',
  'Fixed amount ({currency})': 'المبلغ الثابت ({currency})',
  'Rate ({to} per {from})': 'السعر ({to} لكل {from})',
  'Overtime is paid': 'العمل الإضافي مدفوع',
  "Hours above the month's required hours are paid at the overtime multiplier (Settings → Payroll).":
    'تُدفع الساعات الزائدة عن الساعات المطلوبة في الشهر بمعامل العمل الإضافي (الإعدادات ← الرواتب).',
  'e.g. Annual raise': 'مثال: زيادة سنوية',

  // ---- Reports page ----
  Closed: 'مُقفلة',
  'Ended — not closed': 'انتهت — لم تُقفل',
  '{from} → {to}': '{from} ← {to}',
  'Not finished yet for {n} person (their last day is not over).': 'لم تكتمل بعد لشخص واحد (لم ينتهِ آخر يوم له).',
  'Not finished yet for {n} people (their last day is not over).': 'لم تكتمل بعد لـ {n} أشخاص (لم ينتهِ آخر يوم لهم).',
  '{n} day(s) with a missing clock-in/out ({names}).': '{n} يوم/أيام فيها تسجيل حضور أو انصراف ناقص ({names}).',
  '{n} leave request(s) in this period still waiting for approval.': '{n} طلب/طلبات إجازة في هذه الفترة ما زالت بانتظار الموافقة.',
  'Month-end summary per reporting period. Closing a period freezes its attendance so the figures used for payroll never change afterwards.':
    'ملخص نهاية الشهر لكل فترة. إقفال الفترة يجمِّد حضورها حتى لا تتغير الأرقام المعتمدة للرواتب بعد ذلك.',
  'Report for': 'التقرير عن',
  closed: 'مُقفلة',
  current: 'الحالية',
  'to close': 'بانتظار الإقفال',
  'Custom dates…': 'تواريخ مخصصة…',
  Show: 'عرض',
  'Custom dates': 'تواريخ مخصصة',
  'Closed by {name} on {date}': 'أقفلها {name} في {date}',
  system: 'النظام',
  'version {n} (reopened before)': 'الإصدار {n} (أُعيد فتحها سابقًا)',
  'Close period': 'إقفال الفترة',
  'Check before closing': 'راجِع قبل الإقفال',
  'No missing punches or pending leave — ready to close.': 'لا توجد تسجيلات ناقصة ولا إجازات معلقة — جاهزة للإقفال.',
  'Figures so far — the period is still running.': 'الأرقام حتى الآن — الفترة ما زالت جارية.',
  'Frozen figures (as closed)': 'أرقام مجمَّدة (كما عند الإقفال)',
  'Live figures': 'أرقام مباشرة',
  Expected: 'المطلوب',
  'Computer activity: productive ÷ tracked': 'نشاط الكمبيوتر: المنتج ÷ المسجَّل',
  Late: 'متأخر',
  Early: 'انصراف مبكر',
  Missing: 'ناقص',
  '{productive} productive of {tracked} tracked': '{productive} منتج من أصل {tracked} مسجَّل',
  'Nobody to show for this period': 'لا يوجد أحد لعرضه في هذه الفترة',
  'Click a name for the day-by-day detail. Score = productive ÷ tracked computer time (desktop agent). Excel, CSV and PDF exports are added in Phase 8.':
    'انقر على الاسم لعرض التفاصيل يومًا بيوم. النتيجة = الوقت المنتج ÷ وقت الكمبيوتر المسجَّل (برنامج سطح المكتب). تُضاف تصديرات Excel وCSV وPDF في المرحلة 8.',
  'Close {period}?': 'إقفال {period}؟',
  'Attendance for {dates} is frozen and a summary is stored for every employee. Corrections and leave changes on these dates are then refused until an administrator reopens the period (with a reason).':
    'يُجمَّد الحضور للفترة {dates} ويُحفظ ملخص لكل موظف. بعدها تُرفض التصحيحات وتغييرات الإجازات في هذه التواريخ حتى يعيد مسؤول النظام فتح الفترة (مع ذكر السبب).',
  'e.g. Sent to payroll on 26 Sep': 'مثال: أُرسلت إلى الرواتب في 26 سبتمبر',
  'Reopen {period}?': 'إعادة فتح {period}؟',
  'Attendance for this period becomes editable again. The summary stored at closing is kept as an earlier version; closing again stores a new one.':
    'يصبح حضور هذه الفترة قابلًا للتعديل مجددًا. يُحفظ الملخص المخزَّن عند الإقفال كإصدار سابق، ويُخزَّن ملخص جديد عند الإقفال مرة أخرى.',
  'Reopen period': 'إعادة فتح الفترة',
};
